import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import { Droppable, Draggable } from 'react-beautiful-dnd';

import Cluster from '../Support/Cluster';
import dollarfy from '../Support/Dollarfy';

const breakList = (props) => {

	if(!props.data) return null;

	const modes = ['default', 'hide', 'sort', 'delete'];

	let total = 0;
	let rows = Object.keys(props.data)
		.map(row => {

			const m = props.data[row];
			const r = +row + 1;

			let toggle_icon = <Cluster><span className='mtable__btn__icon'><i className='fas fa-eye'></i></span><span className='mtable__btn__text'> Out</span></Cluster>;
			if(+m.hidden) {
				toggle_icon = <Cluster><span className='mtable__btn__icon mtable__btn__icon--slashed'><i className='fas fa-eye'></i></span><span className='mtable__btn__text'> In</span></Cluster>;
			}
			else {
				total += +m.value;
			}

			let prompt = '';
			let remove_action = props.rdxPrepRow.bind(null,props.id,row);
			let remove_text = ' Remove';
			if(m.deleting) {
				prompt = <div className='prompt'><p>Do you want to remove this item? <button className='prompt__btn' onClick={props.rdxFreeRow.bind(null)}>Cancel</button> <button className='prompt__btn prompt__btn--red' onClick={props.rdxDropRow.bind(null)}>Remove</button></p><div className='prompt__pointer'></div></div>;
				remove_action = props.rdxFreeRow.bind(null);
				remove_text = ' Cancel';
			}

			return (
				<Draggable key={m.id} draggableId={m.id} index={row}>
					{(provided, snapshot) => {
						let row_classes = [];
						if(+m.hidden) row_classes.push('mtable__row-disabled');
						if(snapshot.isDragging) row_classes.push('mtable__row--dragging');

						// Modes (for mobile)
						let mode_column = r;
						if(props.mode === 'hide') {
							let eye_toggle = <Cluster><span className='mtable__btn__icon'><i className='fas fa-eye'></i></span></Cluster>;
							if(+m.hidden) {
								eye_toggle = <Cluster><span className='mtable__btn__icon mtable__btn__icon--slashed'><i className='fas fa-eye'></i></span></Cluster>;
							}
							mode_column = <button className='mtable__btn' onClick={props.rdxToggleRow.bind(null,props.id,row)}>{eye_toggle}</button>;
						}
						else if(props.mode === 'sort') {
							mode_column = <span className='mtable__btn' {...provided.dragHandleProps}><i className='fas fa-sort'></i></span>;
						}
						else if(props.mode === 'delete') {
							mode_column = <button className='mtable__btn' onClick={remove_action}><i className='fas fa-minus-circle'></i></button>;
						}

						return (
							<tr className={row_classes.join(' ')} ref={provided.innerRef} {...provided.draggableProps}>
								<td className='mtable__c1 blankish'><button className='mtable__btn' onClick={remove_action}><i className='fas fa-minus-circle'></i><span className='mtable__btn__text'>{remove_text}</span></button></td>
								<td className='mtable__c2 blankish'><button className='mtable__btn' onClick={props.rdxToggleRow.bind(null,props.id,row)}>{toggle_icon}</button></td>
								<td className='mtable__c3'>{mode_column}{prompt}</td>
								<td className='mtable__c4'><input type='text' value={m.description} placeholder='Item description' onChange={
									(event) => {props.rdxEditListValue(props.id,row,'description',event.target.value)}} /></td>
								<td className='mtable__c5'><input type='number' value={+m.value === 0 ? '' : m.value} placeholder='0' onChange={
									(event) => {props.rdxEditListValue(props.id,row,'value',event.target.value)}} /></td>
								<td className='mtable__c6' {...provided.dragHandleProps}><i className='fas fa-sort'></i></td>
							</tr>
						)
					}}
				</Draggable>
			);

		});

	return (
		<div className='breaklist'>
			<table className='mtable'>
				<thead>
					<tr>
						<th colSpan='2' className='blankish'>Options</th>
						<th className='align-center'><span className='mtable__thead__extra'>Claim </span>#</th>
						<th><span className='align-input'>Description</span></th>
						<th className='align-right'><span className='align-input'>Amount<span className='mtable__thead__extra'> ($)</span></span></th>
						<th className='blankish'>&nbsp;</th>
					</tr>
				</thead>
				<Droppable droppableId={props.id}>
      				{(provided, snapshot) => (
						<tbody ref={provided.innerRef}>
							{rows}
						</tbody>
					)}
				</Droppable>
				<tfoot>
					<tr>
						<td className='mtable__f1 blankish' colSpan='3'><button className='mtable__btn' onClick={props.rdxAddRow.bind(null,props.id)}><i className='fas fa-plus-circle'></i> Add new</button></td>
						<td className='mtable__fspecial'><button className='mtable__btn' onClick={props.rdxNextMode.bind(null,props.field,props.mode,modes)}><i className='fas fa-pencil-alt'></i></button></td>
						<td className='mtable__f2' colSpan='2'><button className='mtable__btn mtable__f2--leftlock' onClick={props.rdxAddRow.bind(null,props.id)}><i className='fas fa-plus-circle'></i> Add</button>TOTAL <span>{dollarfy(total)}</span></td>
						<td className='blankish'>&nbsp;</td>
					</tr>
				</tfoot>
			</table>
		</div>
	);

}

const mapDispatchToProps = dispatch => {
	return {
		rdxAddRow: (id) => 								dispatch(actions.addRow(id)),
		rdxToggleRow: (id,row) => 						dispatch(actions.toggleRow(id,row)),
		rdxPrepRow: (id,row) => 						dispatch(actions.prepRow(id,row)),
		rdxFreeRow: () => 								dispatch(actions.freeRow()),
		rdxDropRow: () => 								dispatch(actions.dropRow()),
		rdxEditListValue: (id,row,item,value) => 		dispatch(actions.editListValue(id,row,item,value)),
		rdxNextMode: (row,current,modes) => {
			let mode_index = modes.indexOf(current);
			mode_index += 1;
			if(mode_index >= modes.length)
				mode_index = 0;
			const new_mode = modes[mode_index];
			dispatch(actions.editField(row,'mode',new_mode));
		}
	};
}


export default connect(null, mapDispatchToProps)(breakList);


// WEBPACK FOOTER //
// ./src/UI/BreakList.js